import { createAsyncThunk } from "@reduxjs/toolkit";
import API from "../../service/Api";


export const createClient = createAsyncThunk("createClient", async (data) => {
    const response = await API.post('client/create', data);
    return response.data;
});
export const uploadFile = createAsyncThunk("uploadFile", async (data) => {
    const response = await API.post('auth/upload', data);
    return response.data;
});

export const getBots = createAsyncThunk("getBots", async ({ page, limit, name }) => {
    const response = await API.get('chatbot', {
        params: { page, limit, name }
    });
    return response.data;
});
export const getAnalytics = createAsyncThunk("getAnalytics", async () => {
    const response = await API.get('admin/dashboard');
    return response.data;
});
export const getStatics = createAsyncThunk("getStatics", async () => {
    const response = await API.get('admin/feedbackDetails');
    return response.data;
});
export const getAdmins = createAsyncThunk("getAdmins", async ({ page, limit, name }) => {
    const response = await API.get('admin/get-admin-list', {
        params: { page, limit, name }
    });
    return response.data;
});
export const getFeedback = createAsyncThunk("getFeedback", async ({ page, limit, name, chatbot }) => {
    const response = await API.get('feedback', {
        params: { page, limit, name, chatbot }
    });
    return response.data;
});
export const getFaq = createAsyncThunk("getFaq", async ({ page, limit, search, chatbotId }) => {
    const response = await API.get('faq', {
        params: { page, limit, search, chatbotId }
    });
    return response.data;
});
export const getPrompt = createAsyncThunk("getPrompt", async ({ page, limit, search }) => {
    const response = await API.get('prompt', {
        params: { page, limit, search }
    });
    return response.data;
});
export const getReviews = createAsyncThunk("getReviews", async ({ page, limit, search }) => {
    const response = await API.get('reviewManagement', {
        params: { page, limit, search }
    });
    return response.data;
});
export const getNewClients = createAsyncThunk("getNewClients", async ({ page, limit, search }) => {
    const response = await API.get('verificationManagement', {
        params: { page, limit, search }
    });
    return response.data;
});
export const getReports = createAsyncThunk("getReports", async ({ page, limit, search }) => {
    const response = await API.get('getReports', {
        params: { page, limit, search }
    });
    return response.data;
});
export const getNotifications = createAsyncThunk("getNotifications", async ({ page, limit, search }) => {
    const response = await API.get('getAllNotifications', {
        params: { page, limit, search }
    });
    return response.data;
});

export const getAllClients = createAsyncThunk("getAllClients", async () => {
    const response = await API.get('client/all');
    return response.data;
});


export const sendForgetPasswordMail = createAsyncThunk("sendForgetPasswordMail", async (data) => {
    const response = await API.post('admin/forgot-password', data);
    return response.data;
});

export const resetPassword = createAsyncThunk("resetPassword", async (data) => {
    const response = await API.post('admin/resetPassword', data);
    return response.data;
});
export const changePassword = createAsyncThunk("changePassword", async (data) => {
    const response = await API.patch('changePassword', data);
    return response.data;
});
export const editProfile = createAsyncThunk("editProfile", async (data) => {
    const response = await API.put('editProfile', data);
    return response.data;
});

export const updateClient = createAsyncThunk("updateClient", async (data) => {
    const response = await API.put('client/edit', data);
    return response.data;
});

export const getAdminDetails = createAsyncThunk("getAdminDetails", async () => {
    const response = await API.get('profile/info');
    return response.data;
});
export const editAdminDetails = createAsyncThunk("editAdminDetails", async (data) => {
    const response = await API.put('profile/edit', data);
    return response.data;
});

export const logoutAction = createAsyncThunk("logoutAction", async (data) => {
    const response = await API.post('auth/logout', data);
    return response.data;
});

export const getClientDetailById = createAsyncThunk("getClientDetailById", async ({ id }) => {
    const response = await API.get('client/details', {
        params: { id }
    });
    return response.data;
});


export const deleteClient = createAsyncThunk("deleteClient", async ({ id }) => {
    const response = await API.delete('client/delete', {
        params: { id }
    });
    return response.data;
});

export const deleteNewUsers = createAsyncThunk("deleteNewUsers", async (data) => {
    const response = await API.post('event/request-delete', data);
    return response.data;
});